declare var _;
import { Puck, DataSet } from './impact.type';

export default function MainController(
  $scope,
  $filter,
  $log,
  $timeout,
  $q,
  $injector,
  $stateParams,
  pageConfig,
  LoadingIndicator,
  api,
  chartGenerationService
) {
  'use strict';
  'ngInject';

  // We load several things manually because the buyer will have them available for injection but the seller
  // version of the Offer Impact page will not.
  let impactService;
  let SaveService;
  let PurchasePlanningPermissions;
  let MicrochartModal;
  let $bsModal;

  try {
    if (pageConfig.buyer) {
      impactService = $injector.get('buyerImpactService');
    } else {
      impactService = $injector.get('sellerImpactService');
    }
  } catch (e) {
    // console.log('Injector does not have either the buyer or seller impact services!');
  }

  try {
    SaveService = $injector.get('SaveService');
  } catch (e) {
    // console.log('Injector does not have SaveService!');
  }

  try {
    PurchasePlanningPermissions = $injector.get('PurchasePlanningPermissions');
  } catch (e) {
    // console.log('Injector does not have PurchasePlanningPermissions!');
  }

  try {
    MicrochartModal = $injector.get('MicrochartModal');
  } catch (e) {
    // console.log('Injector does not have MicrochartModal!');
  }

  try {
    $bsModal = $injector.get('$bsModal');
  } catch (e) {
    // console.log('Injector does not have $bsModal!');
  }

  $scope.titleAndSubtitle = {
    title: 'Offer Impact',
    subtitle: ''
  };

  $scope.predicate = 'name';
  $scope.reverse = false;

  $scope.options = {
    usePrimaryEquivalentCrosses: pageConfig.seller ? true : false
  };

  var aptitudePositiveColor = '#8dc34b';
  var aptitudeNegativeColor = '#f15a28';
  var lightgray = '#d3d3d3';

  var noFractionCurrencyFilter = $filter('nfcurrency');

  // This only works on the buyer side, but the buyer side is the only one which will be looking for this variable
  // in the view. So it all works out.
  $scope.purchasePlanId = $stateParams.purchasePlanId;

  // The page config turns on and off certain page features (for example, tabs and pucks) and determines how we fill
  // in other parts (for example, the overview and the details). It is set based upon the route used to arrive here.
  // So different routes can greatly change the appearance of the page.
  $scope.pageConfig = pageConfig;

  $scope.dataSets = [];
  delete $scope.activePuck;
  delete $scope.activePuckColumnNumber;
  delete $scope.activePuckRowNumber;

  $scope.generateMicroChart = chartGenerationService.generateMicroChart;
  $scope.modal = {
    benchmarks: 'none'
  };

  // This is used to keep track of scenario settings on the seller page, the buyer page will ignore it.
  $scope.cantRunScenario = true;
  $scope.scenario = {
    marketShare: '0'
    // duration: null
  };

  if (pageConfig.buyer) {
    $scope.permissions = PurchasePlanningPermissions;
  }

  ///////////////
  // View Helpers
  ///////////////

  $scope.sort = function (predicate, defaultDirection) {
    var previousPredicate = $scope.predicate;

    if (previousPredicate == predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.predicate = predicate;
      $scope.reverse = defaultDirection || false;
    }
  };

  // Functions to switch between data sets and to know whether a particular one is active for rendering purposes.
  $scope.isActive = function (dataSet) {
    return dataSet === $scope.activeDataSet;
  };

  $scope.setActive = function (dataSet) {
    $scope.activeDataSet = dataSet;
    $scope.titleAndSubtitle.subtitle =
      'For ' + dataSet.aggregationGroupName + ' In ' + dataSet.categoryName;

    if (pageConfig.buyer) {
      $scope.recalculateNumbersForBuyer(dataSet);
      $scope.updateGraphsForBuyer(dataSet.overview);
    }
  };

  $scope.setActiveById = function (dataSets, id) {
    $scope.setActive(_.find(dataSets, { id: id }));
  };

  $scope.puckClass = function (puck): any {
    switch (puck.status) {
      case 'In':
        return { inColor: true };
      case 'Out':
        return { outColor: true };
      case 'Undecided':
        return { undecidedColor: true };
      default:
        return { outColor: true };
    }
  };

  $scope.nameLink = function (puck) {
    if (pageConfig.buyer) {
      return '../buyer/viewBuyerProfile?orgId=' + puck.id;
    } else {
      return '../seller/SellerViewBuyerProfile?orgId=' + puck.id;
    }
  };

  $scope.downloadLink = function (activeDataSet, activePuck) {
    if (pageConfig.buyer) {
      return `/aptitude/buyer/GroupImpactServiceController/downloadFacilities?isGroupRequest=false&includeSavings=true&buyerId=${activePuck.id}&categoryId=${activeDataSet.categoryId}&requestId=${activeDataSet.requestId}&sellerId=${activeDataSet.id}`;
    } else {
      return `/aptitude/seller/SellerPricingViewServiceController/downloadFacilities?buyerId=${activePuck.id}&categoryId=${activeDataSet.categoryId}&isGroupRequest=false&requestId=${activeDataSet.requestId}&includeSavings=true&marketShare=${activeDataSet.overview.marketShare}&priceType=${activeDataSet.overview.duration.priceType}&duration=${activeDataSet.overview.duration.duration}`;
    }
  };

  // Depending upon the information available for the puck, display either nothing, a number, or a message to the user.
  $scope.puckSavings = function (puck) {
    if (puck.savings != null) {
      if ($scope.noSpend(puck)) {
        return 'Spend Not Included';
      } else {
        return noFractionCurrencyFilter(puck.savings);
      }
    } else {
      return ' ';
    }
  };

  /**
   * This got to be enough code that it didn't make sense to keep it in the HTML. It made sense for there to be a
   * convenience function the template could call.
   * @returns {*}
   */
  $scope.generateMacroChart = function (benchmarks) {
    if ($scope.activePuck && $scope.activeDataSet) {
      if (pageConfig.buyer) {
        return chartGenerationService.generateMacroChart(
          $scope.activePuck.microChartData,
          $scope.activeDataSet.overview.targetPotentialMarketShare,
          $scope.activePuck.potentialMarketSharePercentage,
          benchmarks == 'all',
          benchmarks == 'likeMe',
          $scope.activePuck.benchmarksGraph.data.benchmarks
        );
      } else {
        return chartGenerationService.generateMacroChart(
          $scope.activePuck.microChartData,
          undefined,
          undefined,
          benchmarks == 'all',
          benchmarks == 'likeMe',
          $scope.activePuck.benchmarksGraph.data.benchmarks
        );
      }
    } else {
      return null;
    }
  };

  $scope.totalSavings = function (dataSet) {
    if (dataSet && dataSet.overview && dataSet.overview.inSavings != null) {
      return (
        dataSet.overview.inSavings +
        dataSet.overview.outSavings +
        dataSet.overview.undecidedSavings
      );
    } else {
      return 0;
    }
  };

  $scope.totalInOutUndecidedSpend = function (dataSet) {
    if (dataSet && dataSet.overview && dataSet.overview.inSpend != null) {
      return (
        dataSet.overview.inSpend +
        dataSet.overview.outSpend +
        dataSet.overview.undecidedSpend
      );
    } else {
      return 0;
    }
  };

  // Group all of the pucks into rows and return them as row numbers and arrays of the pucks on that given row.
  // For example:
  //   {
  //     "0":[
  //       {"title":"Puck 1","subtitle":""},
  //       {"title":"Puck 2","subtitle":""},
  //       {"title":"Puck 3","subtitle":""},
  //       {"title":"Puck 4","subtitle":""}
  //     ],
  //     "1":[
  //       {"title":"Puck 5","subtitle":""},
  //       {"title":"Puck 6","subtitle":""},
  //             ...
  //   }
  $scope.pucksByRow = function (dataSet: DataSet, buyer) {
    // Note: This work of sorting is cached so we don't do it repeatedly. As long as the data on the pucks
    // themselves doesn't change, the cached version will be used over and over again.
    if (dataSet && dataSet.pucksByRow == null) {
      // First sort all of the pucks alphabetically.
      var firstSort: Puck[] = _.sortBy(dataSet.pucks, 'name');
      var secondSort: Puck[];

      if (buyer) {
        // Sort by the status as well. Because Lo-Dash's sort is stable, this should give us alphabetical sorts
        // within each status group.
        secondSort = _.sortBy(firstSort, function (puck) {
          if (puck.status === 'In') {
            return 0;
          } else if (puck.status === 'Out') {
            return 2;
          } else {
            // Undecided (also used for when we don't have a status)
            return 1;
          }
        });
      } else {
        secondSort = _.sortBy(firstSort, function (puck) {
          if (
            puck.savings == null ||
            (puck.savings === 0 &&
              (puck.continuedSpend == null || puck.continuedSpend === 0))
          ) {
            return 1;
          } else {
            return 0;
          }
        });
      }

      var index = 0;

      var grouped = _.groupBy(secondSort, function () {
        var group = Math.floor(index / 4);
        index++;

        return group;
      });

      // Now we have to do some special shenanigans because we get back an object but ng-repeat doesn't iterate over
      // objects with numbers for keys the way we want. That's because it sorts the keys like they are names.
      var groupedWithPaddedKeys = {};

      _.each(grouped, function (value, key) {
        key = String('00000' + key).slice(-5);
        groupedWithPaddedKeys[key] = value;
      });

      dataSet.pucksByRow = groupedWithPaddedKeys;
    }

    if (!dataSet || !dataSet.pucksByRow) {
      return [];
    } else {
      return dataSet.pucksByRow;
    }
  };

  $scope.showDetails = function (puck, dataSet, columnNumber, rowNumber) {
    $scope.activePuck = puck;
    $scope.activePuckColumnNumber = columnNumber;
    $scope.activePuckRowNumber = rowNumber;

    if (pageConfig.buyer) {
      impactService
        .getPuckDetailsForBuyer(
          puck,
          puck.id,
          dataSet.categoryId,
          dataSet.requestId,
          dataSet.id,
          puck.priceType,
          puck.duration,
          dataSet.overview.targetPotentialMarketShare
        )
        .then(function () {
          // We've got details, generate the micro and macro chart data.
          puck.highchartsMicroData = chartGenerationService.generateMicroChart(
            puck.microChartData.sellers[0],
            dataSet.overview.targetPotentialMarketShare,
            puck.potentialMarketSharePercentage
          );

          setTimeout(function () {
            // Redraw benchmarks graph.
            $scope.$parent.$broadcast('redraw');
          }, 0);
        });
    } else {
      // If this is a "Spend Not Included" puck then we don't need to go get details. To do so is to invite errors
      // which then display to the end user.
      if (!$scope.noSpend(puck)) {
        impactService
          .getPuckDetailsForSeller(
            puck,
            $stateParams.rfpId,
            dataSet.id,
            puck.id,
            dataSet.categoryId,
            dataSet.overview.duration.priceType,
            dataSet.overview.duration.duration,
            dataSet.overview.marketShare,
            $scope.options.usePrimaryEquivalentCrosses
          )
          .then(function () {
            if (pageConfig.naBenchmarks) {
              // We just added in all the benchmarks information, but we really don't want it in this case, it's
              // "not applicable".
              delete puck.benchmarksGraph.data.benchmarks.all.currentRanking;
              delete puck.benchmarksGraph.data.benchmarks.all.plannedRanking;
              delete puck.benchmarksGraph.data.benchmarks.similar
                .currentRanking;
              delete puck.benchmarksGraph.data.benchmarks.similar
                .plannedRanking;
              puck.benchmarksGraph.data.savingsAmount = 0;
            }

            puck.highchartsMicroData = chartGenerationService.generateMicroChart(
              puck.microChartData,
              dataSet.overview.targetPotentialMarketShare,
              puck.potentialMarketSharePercentage
            );
            puck.highchartsMacroData = $scope.generateMacroChart(
              $scope.modal.benchmarks
            );

            setTimeout(function () {
              // Redraw benchmarks graph.
              $scope.$parent.$broadcast('redraw');
            }, 0);
          });
      }
    }
  };

  $scope.hideDetails = function () {
    delete $scope.activePuck;
    delete $scope.activePuckRowNumber;

    // Dump any cached data for the pucks by row. Resorting is only allowed when the details are hidden.
    if ($scope.activeDataSet) {
      delete $scope.activeDataSet.pucksByRow;
    }
  };

  $scope.classToPointToPuck = function () {
    var retVal = {};
    var className = 'pointingToPuck' + ($scope.activePuckColumnNumber + 1);

    retVal[className] = true;

    return retVal;
  };

  $scope.detailVisible = function (rowNumber) {
    return $scope.activePuckRowNumber == rowNumber;
  };

  // These get used within the pucks to set the initial status of the radio buttons (with an override for the seller
  // inclusion status).
  $scope.inStatus = function (puck) {
    if (puck && puck.status === 'In') {
      return true;
    }
  };

  $scope.outStatus = function (puck) {
    if (puck && puck.status === 'Out') {
      return true;
    }
  };

  $scope.canInOut = function (permissions, orgId) {
    // backend needs to add another permission for opt in/out partners
    return (
      permissions &&
      permissions.OPT_IN_OUT &&
      ($scope.isLeader() || orgId === $scope.account.organization.id)
    );
  };

  // Get permissions data
  $scope.cantOptAllIn = function (permissions, pucks: Puck[]) {
    // The user can't opt in if they do not have the permissions to do it or if they do, but everybody is already in.
    if (permissions && pucks && permissions.OPT_IN_OUT && $scope.isLeader()) {
      return _.every(pucks, function (puck) {
        return puck.status === 'In' || puck.status == null;
      });
    } else {
      return true;
    }
  };

  $scope.isLeader = () => {
    return $scope.account && $scope.account.isLeader;
  };

  ///////////////
  // User Actions
  ///////////////
  $scope.save = () => {
    SaveService.save($scope.rfpDetails.id, '', [], true);
  };

  $scope.continue = () => {
    document.location.href = `/aptitude/static/planning.html#/summary/${$scope.rfpDetails.id}`;
  };

  // Only the seller page runs scenarios.
  $scope.runScenario = function () {
    $scope.cantRunScenario = true;

    // Update the pucks info for the given scenario and invalidate puck details which are dependent upon market
    // share or terms.
    impactService
      .runScenario(
        $scope.activeDataSet,
        $stateParams.rfpId,
        $scope.activeDataSet.id,
        $scope.scenario.duration.priceType,
        $scope.scenario.duration.duration,
        $scope.scenario.marketShare,
        $scope.options.usePrimaryEquivalentCrosses
      )
      .then(function () {
        $scope.cantRunScenario = false;

        // Recalculate numbers.
        $scope.recalculateNumbersForSeller($scope.activeDataSet);
        $scope.updateGraphsForSeller($scope.activeDataSet.overview);
      });
  };

  // Only the buyer page can change the in/out status of various systems.
  $scope.setAllIn = function (dataSet: DataSet) {
    let modalPromise = $q.defer();

    $bsModal({
      template: require('./setAllSystemsInModal.html'),
      controller: 'SetAllSystemsInModal',
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      placement: 'center',
      dismissable: true,
      locals: {
        modalPromise: modalPromise
      }
    });

    modalPromise.promise.then(function () {
      // Call the API function to set the seller's inclusion status appropriately and then update our local copy to
      // reflect the change.
      impactService
        .setAllSystemsToIn($stateParams.masterPlanId, dataSet.id, true)
        .then(function () {
          // Cycle through all the seller impacts for the current seller and set status to 'In' for all of them.
          _.each(dataSet.pucks, function (puck) {
            puck.status = 'In';
          });

          // Dump any cached data for the pucks by row. Resorting should happen after this.
          delete $scope.activeDataSet.pucksByRow;

          $scope.recalculateNumbersForBuyer(dataSet);
          $scope.updateGraphsForBuyer(dataSet.overview);
        });
    });
  };

  $scope.updateStatus = function (puck, dataSet, included) {
    // Update the system status to reflect the change.
    impactService.setSystemStatus(
      $stateParams.masterPlanId,
      puck.id,
      dataSet.id,
      included
    );

    // Update our local cached copy to reflect the updated status.
    puck.status = included ? 'In' : 'Out';

    $scope.recalculateNumbersForBuyer(dataSet);
    $scope.updateGraphsForBuyer(dataSet.overview);
  };

  $scope.zoomMicroChart = function (sellerName) {
    if (pageConfig.buyer) {
      // Open the microchart modal
      MicrochartModal.openMicrochartModal(
        $scope.activePuck.highchartsMicroData,
        sellerName
      );
    }
  };

  //////////////////////
  // Page Initialization
  //////////////////////
  LoadingIndicator.show();

  let pageInitializationPromises: any[] = [];
  pageInitializationPromises.push(
    api.users.currentUser().then((account) => {
      $scope.account = account;

      if (pageConfig.buyer) {
        pageInitializationPromises.push(
          api.users
            .loadPurchasePlanningPermissions(
              account.userId,
              $stateParams.purchasePlanId
            )
            .then((permissions) => {
              $scope.permissions.setPermissions(permissions);
            })
        );
      }
    })
  );

  pageInitializationPromises.push(
    api.features.getFeatures().then((response) => {
      $scope.featureList = response;
    })
  );

  // Here we split the page initialization between what the buyer version of the page does vs. the seller version.
  // The reason this all works is because there's a common data structure used for the page whether you're on the
  // buyer or seller side. As long as the services build up that data structure, the controller can handle the few
  // other control and interaction differences.
  if (pageConfig.buyer) {
    // Normally we don't have to notify outside our controller but the control at the bottom of the Purchase
    // Planning page is wholly separate and it "needs to know" when we're done so it can enable a link. Bleh.
    // $scope.$parent.loading = true;

    // I hate having to stack API calls like this but we've got to know which one is the master plan ID in case the
    // ID in the route was for a partner's purchase plan rather than the master purchase plan.
    pageInitializationPromises.push(
      impactService
        .getMasterPlanId($stateParams.purchasePlanId)
        .then(function (masterPlanIdResults) {
          $stateParams.masterPlanId = masterPlanIdResults.id;

          var promises = impactService.getDataSetsForBuyer(
            $stateParams.masterPlanId
          );

          promises.masterPlanPromise.then(function (results) {
            // If we're on a page without tabs, this will be an array with only a single dataSet.
            $scope.dataSets = results;

            impactService
              .getRfpDetails($scope.dataSets[0].requestId)
              .then(function (results) {
                $scope.rfpDetails = results;
              });

            // impactService.getOldRfp($scope.dataSets[0].requestId).then(results => {
            //   $scope.oldRfp = results;
            // });

            api.rfps
              .getActivePurchasePlan($scope.dataSets[0].requestId)
              .then((response) => {
                $scope.activePurchasePlan = response;
              });

            // Once we've gotten all the puck information, we can ask about the user's permissions for the page.
            // Attempting to do so before this point may cause the back-end to return incorrect results.
            promises.puckDetailsPromise.then(
              function () {
                _.each($scope.dataSets, function (dataSet: any) {
                  // Permissions used to be blanket for the entire page, but not anymore, we need to be looking at
                  // permissions as a per/seller kind of thing. That's because we could have signed for one seller and
                  // not for another.
                  impactService
                    .getApplicationPermissions(
                      'GROUP_MASTER_IMPACT',
                      $stateParams.masterPlanId,
                      dataSet.id
                    )
                    .then(function (results) {
                      dataSet.permissions = results;
                    });
                });

                // $scope.$parent.loading = false;
              },
              function () {
                // This handles the failure situation.
              },
              function () {
                // This is the notification function and receives calls every time we receive the details for a puck.
                // If we're not currently displaying details, get rid of the pucks by row info because we might want a
                // re-sort to take place.
                if (!$scope.activePuckRowNumber) {
                  delete $scope.activeDataSet.pucksByRow;
                }

                // Recalculate numbers.
                $scope.recalculateNumbersForBuyer($scope.activeDataSet);
                $scope.updateGraphsForBuyer($scope.activeDataSet.overview);
              }
            );

            if ($stateParams.sellerId) {
              $scope.setActiveById(
                $scope.dataSets,
                parseInt($stateParams.sellerId, 10)
              );
            } else {
              $scope.setActive($scope.dataSets[0]);
            }
          });
        })
    );
  } else {
    pageInitializationPromises.push(
      impactService.getRfpDetails($stateParams.rfpId).then(function (results) {
        $scope.rfpDetails = results;
      })
    );

    // Get the initial data load for the page.
    pageInitializationPromises.push(
      impactService
        .getDataSetForSeller($stateParams.rfpId)
        .then(function (results) {
          // Seller data always comes back with only a single data set because we're only seeing how our prices affect
          // the buyer. We're not comparing our offer with our competitors.
          $scope.dataSets = results;

          // The active data set is always the first one, sellers never see data for more than one seller.
          // $scope.activeDataSet = $scope.dataSets[0];
          $scope.setActive($scope.dataSets[0]);

          impactService
            .getResponseData($stateParams.rfpId)
            .then(function (results) {
              $scope.durationsOptions = results.durationsOptions;

              var firstDuration = results.durationsOptions[0];

              // The first duration is just the first in the list of available durations.
              $scope.scenario.duration = firstDuration;

              $scope.activeDataSet.name = results.name;
              $scope.activeDataSet.id = results.id;

              impactService
                .runScenario(
                  $scope.activeDataSet,
                  $stateParams.rfpId,
                  $scope.activeDataSet.id,
                  firstDuration.priceType,
                  firstDuration.duration,
                  0,
                  $scope.options.usePrimaryEquivalentCrosses
                )
                .then(
                  function () {
                    $scope.cantRunScenario = false;
                  },
                  function () {
                    // This is the failure function.
                  },
                  function () {
                    // This is the notification function.
                    if (!$scope.activePuckRowNumber) {
                      delete $scope.activeDataSet.pucksByRow;
                    }

                    // Recalculate numbers.
                    $scope.recalculateNumbersForSeller($scope.activeDataSet);
                    $scope.updateGraphsForSeller($scope.activeDataSet.overview);
                  }
                );
            });
        })
    );
  }

  LoadingIndicator.waitFor($q.all(pageInitializationPromises));

  ///////////////////
  // Helper Functions
  ///////////////////

  // We're calculating a lot of percentages, this handles it and handles the _frequent_ case where the denominator
  // is zero so we don't get Infinity.
  function percentOrZero(numerator, denominator) {
    if (denominator !== 0) {
      // Oddly enough, at the moment calculations for some of our percentages can end up greater than 100%.
      // In those cases we max out at 100%.
      var percentage = Math.round((numerator / denominator) * 100.0);
      return Math.min(percentage, 100);
    } else {
      return 0;
    }
  }

  $scope.recalculateNumbersForBuyer = function (dataSet) {
    // Blow away the current counts, but preserve the market share number which we got from the server.
    $scope.zeroOutNumbersForBuyer(dataSet);

    // Now iterate through all the members and redo the calculations for each one.
    // Get all the detailed information for each system.
    _.each(dataSet.pucks, function (puck) {
      $scope.updateNumbersForBuyer(dataSet, puck);
    });
  };

  $scope.zeroOutNumbersForBuyer = function (dataSet) {
    var overview = dataSet.overview;

    overview.notSavingCount = 0;

    // This is "total" spend, but it's really only the total spend for the systems which are in.
    overview.totalSpend = 0;
    overview.totalPotentialSpend = 0;

    overview.underCommittedCount = 0;

    overview.inCount = 0;
    overview.inSavings = 0;
    overview.inSpend = 0;

    overview.undecidedCount = 0;
    overview.undecidedSavings = 0;
    overview.undecidedSpend = 0;

    overview.outCount = 0;
    overview.outSavings = 0;
    overview.outSpend = 0;

    overview.totalCount = 0;
  };

  $scope.updateNumbersForBuyer = function (dataSet, puck) {
    var overview = dataSet.overview;

    // These are the aggregate totals.
    overview.totalCount++;

    // If member is upside down(savings < 0) for this seller, add them to the not saving count.
    if (puck.savings < 0) {
      overview.notSavingCount++;
    }

    // Aggregate these totals separately so they can be used to calculate market share.
    switch (puck.status) {
      case 'In':
        overview.inCount++;
        overview.inSavings += puck.savings;
        overview.inSpend += puck.plannedSpend;

        overview.totalSpend += puck.plannedSpend;
        overview.totalPotentialSpend += puck.potentialSpend;

        // If this system is under-committed, add it to the under-committed overview.
        if (
          percentOrZero(puck.plannedSpend, puck.potentialSpend) <
          overview.targetPotentialMarketShare
        ) {
          overview.underCommittedCount++;
        }

        break;
      case 'Undecided':
        overview.undecidedCount++;
        overview.undecidedSavings += puck.savings;
        overview.undecidedSpend += puck.plannedSpend;
        break;
      case 'Out':
        overview.outCount++;
        overview.outSavings += puck.savings;
        overview.outSpend += puck.plannedSpend;
        break;
    }
  };

  $scope.updateGraphsForBuyer = function (overview) {
    // Copy numbers to all of the following so the various bar and dial gauges update to the correct values.
    overview.gauges['in'] = percentOrZero(
      overview.inCount,
      overview.totalCount
    );
    overview.gauges.undecided = percentOrZero(
      overview.undecidedCount,
      overview.totalCount
    );
    overview.gauges.out = percentOrZero(overview.outCount, overview.totalCount);

    overview.dials.notSaving.number = overview.notSavingCount;
    overview.dials.notSaving.percentage = percentOrZero(
      overview.notSavingCount,
      overview.totalCount
    );
    overview.dials.notSaving.label = 'of ' + overview.totalCount;

    if (overview.dials.notSaving.percentage === 0) {
      overview.dials.notSaving.notColor = aptitudePositiveColor;
      overview.dials.notSaving.color = aptitudePositiveColor;
    } else {
      overview.dials.notSaving.notColor = lightgray;
      overview.dials.notSaving.color = aptitudeNegativeColor;
    }

    var potentialMarketShare = percentOrZero(
      overview.totalSpend,
      overview.totalPotentialSpend
    );
    overview.dials.potentialMarketShare.percentage = potentialMarketShare;
    overview.dials.potentialMarketShare.number = potentialMarketShare;

    if (potentialMarketShare >= overview.targetPotentialMarketShare) {
      overview.dials.potentialMarketShare.color = aptitudePositiveColor;
    } else {
      overview.dials.potentialMarketShare.color = aptitudeNegativeColor;
    }

    // Again, always going to be using the negative color here.
    overview.dials.underCommitted.number = overview.underCommittedCount;
    overview.dials.underCommitted.percentage = percentOrZero(
      overview.underCommittedCount,
      overview.inCount
    );
  };

  $scope.recalculateNumbersForSeller = function (dataSet) {
    dataSet.overview.totalCount = 0;
    dataSet.overview.notSavingCount = 0;
    dataSet.overview.metTargetMarketShare = 0;

    dataSet.overview.totalSpend = 0;
    dataSet.overview.totalPotentialSpend = 0;

    dataSet.overview.total12MonthGroupSavings = 0;

    _.each(dataSet.pucks, function (puck: Puck) {
      // Total count does not include systems for which we have no spend data.
      if (!$scope.noSpend(puck)) {
        dataSet.overview.totalCount++;
      }
      dataSet.overview.total12MonthGroupSavings += puck.savings;

      if (puck.savings < 0) {
        dataSet.overview.notSavingCount++;
      }

      if (puck.potentialMarketSharePercentage >= dataSet.overview.marketShare) {
        dataSet.overview.metTargetMarketShare++;
      }
    });
  };

  $scope.updateGraphsForSeller = function (overview) {
    overview.dials.notSaving.number = overview.notSavingCount;
    overview.dials.notSaving.percentage = percentOrZero(
      overview.notSavingCount,
      overview.totalCount
    );
    overview.dials.notSaving.label = 'of ' + overview.totalCount;

    if (overview.dials.notSaving.percentage === 0) {
      overview.dials.notSaving.notColor = aptitudePositiveColor;
      overview.dials.notSaving.color = aptitudePositiveColor;
    } else {
      overview.dials.notSaving.notColor = lightgray;
      overview.dials.notSaving.color = aptitudeNegativeColor;
    }

    var percentage = percentOrZero(
      overview.metTargetMarketShare,
      overview.totalCount
    );

    overview.dials.abilityToReachTarget.number = Math.round(percentage);
    overview.dials.abilityToReachTarget.percentage = percentage;

    if (percentage >= overview.marketShare) {
      overview.dials.abilityToReachTarget.color = aptitudePositiveColor;
    } else {
      overview.dials.abilityToReachTarget.color = aptitudeNegativeColor;
    }
  };

  ////////////////////
  // Modal Controllers
  ////////////////////

  // This is a super-simple controller which can be used for modals with OK or OK/Cancel buttons only.
  // function modalInstanceCtrl($scope, $modalInstance) {
  //   $scope.ok = function () {
  //     $modalInstance.close();
  //   };

  //   $scope.cancel = function () {
  //     $modalInstance.dismiss('cancel');
  //   };
  // }

  $scope.noSpend = function (puck) {
    return (
      pageConfig.seller &&
      (puck.savings == null ||
        (puck.savings === 0 &&
          (puck.continuedSpend == null || puck.continuedSpend === 0)))
    );
  };
}
